export default "__VITE_ASSET__7b0a01b0__"